"use client";

import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  title: "MECANIZADO DE ALTA CONFIABILIDAD",
  image: "https://mivgrupo.com/wp-content/uploads/2026/04/machining_Tiny.webp?v=6k1mm94y1a8"
}, {
  title: "FABRICACIÓN, REPARACIÓN Y MANTENIMIENTO",
  image: "https://mivgrupo.com/wp-content/uploads/2026/04/Vnexus-Machining-1.jpg?v=x4g2sby9sg"
}, {
  title: "ENGRANAJES Y REDUCTORES DE TRABAJO PESADO",
  image: "https://mivgrupo.com/wp-content/uploads/2026/04/post_understanding-gear-reducers-and-their-role-in-heavy-industry.webp?v=erz25v7onb"
}, {
  title: "INTERCAMBIADORES PARA PETRÓLEO, GAS Y PETROQUÍMICA",
  image: "https://mivgrupo.com/wp-content/uploads/2026/04/Techs_MIV_HE_Tiny.jpg?v=sqnorzfsgdl"
}];
export default function NuestrosPilares() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="113684" id="capacidades" className="dark bg-background text-foreground py-12 px-2 md:px-4 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-bold tracking-tighter uppercase font-default !text-4xl">SOLUCIONES DE INGENIERÍA:&nbsp; &nbsp;IMPULSANDO EL MÁXIMO IMPACTO OPERACIONAL</h2>
          <div className="w-24 h-1 bg-primary mx-auto mt-6 shadow-[0_0_15px_rgba(251,146,60,0.5)]"></div>
        </div>

        <div ref={ref} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {pillars.map((pillar, i) => <Card key={i} data-index={i} className="p-0 gap-0 rounded-sm border border-white/5 overflow-hidden group relative bg-secondary/10 backdrop-blur-md shadow-lg transition-transform duration-500 hover:scale-[1.02]">
              <AspectRatio ratio={4 / 5}>
                <img src={pillar.image} alt={pillar.title} className="object-cover w-full h-full grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out opacity-80 group-hover:opacity-100" />
                <div className="absolute inset-0 bg-background/80 backdrop-blur-sm flex items-center justify-center translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-in-out border-t border-primary/30">
                  <h3 className="text-primary font-bold text-2xl uppercase tracking-widest text-center px-6 font-default">
                    {pillar.title}
                  </h3>
                </div>
              </AspectRatio>
            </Card>)}
        </div>
      </div>
    </section>;
}